import React, { useRef } from 'react';
import { Provider } from 'react-redux';
import { makeStore, AppStore } from 'src/redux/store';
import { ForumsPageProps } from 'src/types/NextApp';
import setSSRPageData from 'src/redux/setSSRPageData';

type StoreProviderProps = ForumsPageProps & {
  isShallow: boolean
};
const StoreProvider: React.FC<React.PropsWithChildren<StoreProviderProps>> = ({
  children,
  isShallow,
  ...pageResponseData
}) => {
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore();
  }

  if (pageResponseData.pageType && !isShallow) {
    setSSRPageData(pageResponseData, storeRef.current.dispatch);
  }

  return (
    <Provider store={storeRef.current}>
      {children}
    </Provider>
  );
};

export default StoreProvider;
